var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecEngineDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 18.334H13.3327",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 15.834H15.8327",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 13.334H18.3327",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C7.23858 5 5 7.23858 5 10C5 11.2681 5.47205 12.4259 6.25 13.3073H13.75C14.528 12.4259 15 11.2681 15 10C15 7.23858 12.7614 5 10 5Z",
    stroke: "#fff",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 8.33398L10.531 7.80365C10.2381 7.51076 9.76321 7.51076 9.47032 7.80365L10.0007 8.33398ZM11.137 10.531C11.4299 10.8239 11.9048 10.8239 12.1976 10.531C12.4905 10.2381 12.4905 9.76321 12.1976 9.47032L11.137 10.531ZM7.80365 9.47032C7.51076 9.76321 7.51076 10.2381 7.80365 10.531C8.09655 10.8239 8.57142 10.8239 8.86431 10.531L7.80365 9.47032ZM10.0007 13.334H10.7507V8.33398H10.0007H9.25065V13.334H10.0007ZM10.0007 8.33398L9.47032 8.86431L11.137 10.531L11.6673 10.0007L12.1976 9.47032L10.531 7.80365L10.0007 8.33398ZM10.0007 8.33398L9.47032 7.80365L7.80365 9.47032L8.33398 10.0007L8.86431 10.531L10.531 8.86431L10.0007 8.33398Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66602V2.49935",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 10L17.5007 10",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10L1.66667 10",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8926 4.10742L15.5652 4.43479",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43555 4.43555L4.10818 4.10818",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecEngineDark);
export default __webpack_public_path__ + "static/media/dec_engine_dark.1eb46275c7b58e9386a84bc618af2d13.svg";
export { ForwardRef as ReactComponent };